import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StoreAccessoryRequestSearch } from '../../../models/api-store/store-accessory/store-accessory.request.model';
import { StoreAccessoryService } from '../../../services/api-store/store-accessory/store-accessory.service';
import { FALSE } from '../../../utils/config/const';

@Component({
  selector: 'app-choice-storeaccessory-modal',
  templateUrl: './choice-storeaccessory-modal.component.html'
})
export class ChoiceStoreaccessoryModalComponent implements OnInit {

  isButtonSaveDisabled: boolean;
  errorMsg_accessoryIds = "Nessun accessorio trovato...";
  constructor(
    public activeModal: NgbActiveModal,
    private storeAccessoryService: StoreAccessoryService
  ) { }

  ngOnInit(): void {
    this.isButtonSaveDisabled = true;
  }



  //Autocomplete - accessoryIds  <- Lista comodità cliente in negozio
  @ViewChild('accessoryIds ') accessoryIds;
  accessoryIds_Keyword = 'name';
  accessoryIds_Suggestion: any = [];
  accessoryIds_Selected: any = [];
  accessoryIds_errorMsg: string;
  accessoryIds_isKeywordLoadingResult: boolean;
  getFilter_accessoryIds(event) {
    let request = new StoreAccessoryRequestSearch();
    request.name = event;
    request.published = true;
    request.pageNumber = 0
    request.pageSize = 20
    return request
  }
  fill_accessoryIds_Suggestion(response) {
    for (let data of response.data) {
      let trovato = false;
      for (let j = 0; j < this.accessoryIds_Selected.length && !trovato; j++) {
        if (data.id == this.accessoryIds_Selected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.accessoryIds_Suggestion.push(data);
      }
    }
  }
  getList_accessoryIds(event) {
    this.accessoryIds_isKeywordLoadingResult = true;
    let request = this.getFilter_accessoryIds(event);
    this.storeAccessoryService.search(request).subscribe(response => {
      this.accessoryIds_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_accessoryIds_Suggestion(response);
      }
      this.accessoryIds_isKeywordLoadingResult = false;
    });
  }
  searchCleared__accessoryIds() {
    this.accessoryIds_Suggestion = [];
  }
  selectEvent__accessoryIds(item) {
    this.isButtonSaveDisabled = false;
    this.accessoryIds_Selected.push(item);
    this.accessoryIds.clear();
  }
  onFocused__accessoryIds(e) {
    console.log(e);
    this.getList_accessoryIds("");
    // do something when input is focused
  }
  //Chip list - accessoryIds <- Galleria interna immagini
  labelKeys_accessoryIds = ["name"];
  onChangeItemList_accessoryIds($event) {
    if ($event != null) {
      if ($event.length > 0) {
        this.isButtonSaveDisabled = false;
      } else {
        this.isButtonSaveDisabled = true;
      }
    } else {
      this.isButtonSaveDisabled = true;
    }
  }

  clickButtonSave() {
    if (this.isButtonSaveDisabled == FALSE) {
      this.activeModal.close(this.accessoryIds_Selected);
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }

}
